<template>
    <div class="display-inline-flex">
        <div :class="{'stack-s': !fluid}">
            <span class="inline-s">On the</span>
            <v-popper-select
                label="Day"
                :options="dayOptions"
                :value="day"
                :validate="validate.day"
                @input="value => updateDay(value)"/>
            <span>of the month</span>
        </div>
        <div class="display-flex">
                    <span class="inline-s text-muted">
                        <span v-if="fluid">&nbsp;</span>
                        <template v-if="timeIsRequired">&nbsp;at</template><template v-else>(Optional Time)</template>
                    </span>
            <v-date-input :no-flex="true"
                          type="time"
                          :value="time"
                          :validate="validate.time"
                          @input="updateTime">
                <template slot="hours-input" slot-scope="hours">
                    <v-popper-select
                        label="Hours"
                        :options="prepareDateTimeOptions(hours.options)"
                        :value="hours.value"
                        @input="hours.input"/>
                </template>
                <template slot="minutes-input" slot-scope="minutes">
                    <v-popper-select
                        label="Minutes"
                        :options="prepareDateTimeOptions(minutes.options)"
                        :value="minutes.value"
                        @input="minutes.input"/>
                </template>
            </v-date-input>
        </div>
    </div>
</template>

<script>
    import {vDateInput, vPopperSelect} from '@/components/form';
    import prepareDateTimeOptions from '@/components/inline-time-period/prepare-datetime-options';
    import PeriodComponentMixin from '@/components/inline-time-period/period-component-mixin';

    export default {
        name: 'day-of-month',
        components: {
            vPopperSelect, vDateInput,
        },
        mixins: [PeriodComponentMixin],
        props: {
            day: {},
            time: {},
        },
        computed: {
            timeIsRequired() {
                return this.validate.time.required === true;
            },
            dayOptions() {
                return new Array(31)
                    .fill(0)
                    .map((v, i) => {
                        const value = i + 1;
                        const label = this.$filters.ordinal(value);
                        return {
                            value,
                            label,
                        };
                    });
            },
        },
        methods: {
            prepareDateTimeOptions(options) {
                return prepareDateTimeOptions(options);
            },
            updateDay(day) {
                this.$emit('update', {day});
            },
            updateTime(time) {
                this.$emit('update', {time});
            },
        },
    };
</script>
